import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z",
      stroke: "black",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
      stroke: "black",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
      stroke: "black",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14 16a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2z",
      stroke: "black",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }